import { Component, Input } from '@angular/core';

@Component({
    selector: 'finder-anchor',
    templateUrl: './anchor.component.html',
    styleUrls: ['./anchor.component.scss']
})
export class AnchorComponent {

    @Input() title = '';
    // Leaving empty to use on *ngIf
    @Input() href;
    @Input() id = null;
    @Input() target = '_self';
    @Input() ariaLabel = null;
    @Input() tabIndex = 0;
    @Input() linkId: string;
    @Input() role: string;
    @Input() ariaPressed: boolean;
    @Input() ariaCurrent: string;
    @Input() allowTracking: boolean = false;

    // Internal link, needs to be handled by the router
    @Input() internal = false;

    constructor() {}
}
